import React, { createContext, useContext, useState, useEffect } from 'react';
import apiFetch from '../lib/supabaseClient';

const AuthContext = createContext({});

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing token on mount
    const token = localStorage.getItem('supertask_token');
    if (token) {
      apiFetch('/auth/me')
        .then((userData) => {
          setUser(userData);
        })
        .catch(() => {
          localStorage.removeItem('supertask_token');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const value = {
    signIn: async (email, password) => {
      const data = await apiFetch('/auth/login', {
        method: 'POST',
        body: { email, password },
      });
      localStorage.setItem('supertask_token', data.token);
      setUser(data.user);
      return data;
    },

    signUp: async () => {
      throw new Error('Signup is not available yet');
    },

    signOut: async () => {
      localStorage.removeItem('supertask_token');
      setUser(null);
    },

    resetPassword: async () => {
      throw new Error('Password reset is not available yet');
    },

    updatePassword: async () => {
      throw new Error('Password update is not available yet');
    },

    signInWithGoogle: async () => {
      throw new Error('Google sign-in is not available yet');
    },

    user,
    session: user ? { user } : null,
    loading,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
